<template>
  <virtual-assistant-lib
    :send-chat-service="sendChatService"
    :get-citation-file-service="getCitationFileService"
    :download-service="downloadService"
    :user-full-name="userFullName"
  />
</template>

<script>
// libs
import VirtualAssistantLib from "@quisit/virtual-assistant";

// services
import { sendChat, getCitationFile } from "@/services/virtualAssistant.js";
import documentService from "@/services/documents.js";

export default {
  name: "VirtualAssistant",
  components: {
    VirtualAssistantLib
  },
  computed: {
    userFullName() {
      return `${this.userProfile.firstname} ${this.userProfile.lastpaternalname}`;
    }
  },
  methods: {
    sendChatService(payload) {
      return sendChat(payload);
    },
    getCitationFileService(payload) {
      return getCitationFile(payload);
    },
    downloadService(payload) {
      return documentService.Download(payload);
    }
  }
};
</script>
